import { Box } from '@primer/react';
import React, { useMemo } from 'react';
interface IUserAvatarProps {
    url?: string,
    fullName?: string,
    size?: "small" | "medium" | "large" | "xlarge" | "xxlarge",
}
const UserAvatar = (props: IUserAvatarProps) => {
    // console.log({
    //     xxxx: props.url,
    //     fullName: props.fullName
    // });

   const character = useMemo(() => {
        if (props.fullName) {
            const texts = props.fullName.trim().split(' ');
            return texts[texts.length - 1].split('')[0];
        }
        return "nochar";
    }, [props.fullName])
    const width = useMemo(() => {
        if (props.size === "small") {
            return "16px";
        }
        if (props.size === "large") {
            return "32px";
        }
        if (props.size === "xlarge") {
            return "40px";
        }
        if (props.size === "xxlarge") {
            return "50px";
        }
        return "24px";
    }, [props.size])
    // console.log({
    //     character,
    //     url: props.url
    // });

    return (
        <Box>
            {props.url && props.url != 'null' && props.url != "" &&
                <img 
                    alt='avatar' 
                    src={props.url}
                    width={width}
                    height={width}
                    style={{
                        borderRadius: "50%",
                        objectFit: "cover"
                    }}
                    onError={(e) => {
                        // Fallback to default avatar if image fails to load
                        const target = e.target as HTMLImageElement;
                        target.src = `../../../../images/${character}.png`;
                    }}
                />
            }
            {(!props.url || props.url === "" || props.url === 'null') &&
                <img alt='avatar' src={`../../../../images/${character}.png`}
                    width={width}
                    height={width}
                    style={{
                        borderRadius: "50%",
                        objectFit: "cover"
                    }}
                />
            }
        </Box>
    );
};

export default UserAvatar;